/**
 * Main Layout Component
 * Provides the basic page structure with header and footer
 */

import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ErrorBoundary from '../common/ErrorBoundary';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from '../common/ScrollToTop';
import AnalyticsTracker from '../common/AnalyticsTracker';
import PwaInstallBanner from '../common/PwaInstallBanner';
import SessionTimer from '../SessionTimer';

const MainLayout: React.FC = () => {
  const location = useLocation();
  const isMessagesPage = location.pathname.startsWith('/messages');

  return (
    <div className={`flex flex-col ${isMessagesPage ? 'h-screen h-[100dvh] overflow-hidden' : 'min-h-screen'} bg-white`}>
      <div className="shrink-0">
        <Header />
      </div>
      <main className={`flex-1 w-full ${isMessagesPage ? 'overflow-hidden flex flex-col min-h-0' : ''}`}>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
      {!isMessagesPage && <Footer />}
      {!isMessagesPage && <ScrollToTop />}
      <AnalyticsTracker />
      <PwaInstallBanner />
      <SessionTimer />
    </div>
  );
};

export default MainLayout;


